<arm-dialog (onCancel)="onCancel()" (onSubmit)="onSubmit()" [title]="'Advanced Search'">
  <div class="search-container">
    <div class="search-column">
      <mat-form-field>
        <mat-label>User</mat-label>
        <input [(ngModel)]="search.user" matInput name="name">
      </mat-form-field>

      <mat-form-field>
        <mat-label>Host</mat-label>
        <input [(ngModel)]="search.host" matInput name="serial">
      </mat-form-field>


      <ac-input-container label="Node"   >
        <ac-select
          [(acModel)]="search.nodeId"
          [items]="search.nodesOptions"
          [allowClear]="true"
          [multiple]="false"
          [bindValue]="'value'"
          [bindLabel]="'text'">
        </ac-select>
      </ac-input-container>

      <ac-input-container label="Peer Connection"  >
        <ac-select
          [(acModel)]="search.pConId"
          [items]="search.pConsOptions"
          [allowClear]="true"
          [multiple]="false"
          [bindValue]="'value'"
          [bindLabel]="'text'"
          [groupBy]="'name'" >
        </ac-select>
      </ac-input-container>

    </div>
  </div>
</arm-dialog>

